import { create } from 'zustand';

interface AffiliateUser {
  id?: string;
  email?: string;
  referral_code?: string;
  [key: string]: any;
}

interface AffiliateSessionState {
  affiliateUserId: string | null;
  user: AffiliateUser | null;
  setSession: (affiliateUserId: string, user?: AffiliateUser | null) => void;
  clearSession: () => void;
}

export const useAffiliateSessionStore = create<AffiliateSessionState>((set) => ({
  affiliateUserId: null,
  user: null,
  setSession: (affiliateUserId: string, user: AffiliateUser | null = null) =>
    set({ affiliateUserId, user }),
  clearSession: () => set({ affiliateUserId: null, user: null })
}));
